/**
 * @name fillDropdown - Function for getting change offer subscription dropdown in navbar
 * @param {array} mobileSubscription - Array of change offers
 * @param {function} setDropdownContent - setstate for setting the dropdown_Content state
 */
export const fillDropdown = ({ mobileSubscription, setDropdownContent }) => {
  const subscriptionIds = [];
  mobileSubscription.map(subscription =>
    subscriptionIds.push({
      value: subscription.id,
      label: subscription.id,
      msisdn: subscription?.servicesForSubscription[0]?.msisdn,
      changeOffer: subscription?.coEligiblity?.contractRenewal,
      totalAmountVatIncluded: subscription?.coEligiblity?.totalAmountVatIncluded,
    })
  );
  setDropdownContent(subscriptionIds);
};

/**
 * @name crossSellOrChangeOfferOnLoadEligibilityChecker - Function for getting changeOffer Or crossSell eligibility onLoad of handsets page
 * @param {object} eligibility - Eligiblity object which was provided as server side prop to index page
 * @param {function} getTokenFromCookies - function to get token
 * @param {state} setCustomerEligibility - state for setting customer eligiblity
 * @param {function} getLocalStorage - function from uselocalstorage hook for getting the localstorage value
 * @param {function} hasLocalStorageValue - function from uselocalstorage hook for getting the localstorage value for ION keyWord
 * @param {function} mobileEligibilityCheck - function to get the mobileEligiblity if user is logged in
 * @param {state} setCoMobileSubscriptions - state for storing change offer eligiblity
 * @param {function} getCookie - function to getting cookie
 * @param {function} setCookie - function to set cookie value
 * @param {state} setDropdownContent - state for storing co dropdown in nav bar which shows number eligible for co journey
 */
export const crossSellOrChangeOfferOnLoadEligibilityChecker = async ({
  eligibility,
  getTokenFromCookies,
  setCustomerEligibility,
  getLocalStorage,
  hasLocalStorageValue,
  mobileEligibilityCheck,
  setCoMobileSubscriptions,
  getCookie,
  setCookie,
  setDropdownContent,
}) => {
  try {
    let Eligibility = eligibility;
    let loadJourneyPickerModal = false;
    let isCrossSellEligible = false;
    let isChangeOfferEligible = { value: false, CoEligiblenumber: 0, coEligiblityDetails: [] };
    Eligibility = eligibility.constructor !== Object ? JSON.parse(eligibility) : eligibility;
    const token = getTokenFromCookies();
    // This if will be called if eligbility prop from server side does not have proper value then we will calulate it's value
    // at client side by calling mobileEligibilityCheck function.
    if (
      token &&
      !getLocalStorage('PROSPECTUUID') &&
      hasLocalStorageValue('ION_ORDER_DETAILS') &&
      Object.keys(Eligibility).length === 0
    ) {
      const newEligibility = await mobileEligibilityCheck({ token });
      const EligibilityData =
        newEligibility.constructor !== Object ? JSON.parse(newEligibility) : newEligibility;
      const filteredMobileSubs = EligibilityData?.subscriptions?.filter(
        sg => sg?.serviceGroup === 'MOBILE'
      );
      const coMobileEligible = filteredMobileSubs?.filter(
        ele =>
          ele?.coEligiblity?.contractRenewal === true &&
          ele?.coEligiblity?.chargeCode !== 'UPFRONT_ECC'
      );
      const csMobileEligible = EligibilityData?.crossSellEligibility?.serviceGroups?.filter(
        servicegrp => servicegrp.serviceGroup === 'MOBILE'
      )[0]?.eligible;
      if (coMobileEligible.length > 0 && csMobileEligible) {
        loadJourneyPickerModal =
          getCookie('cart_Type') !== 'CHANGE_OFFER' && getCookie('cart_Type') !== 'CROSS_SELL';
        const tempCoMobileSubscriptions = coMobileEligible || [];
        setCoMobileSubscriptions(tempCoMobileSubscriptions);
        if (tempCoMobileSubscriptions)
          setCookie('ION', 'selected_subscription', JSON.stringify(tempCoMobileSubscriptions));
        fillDropdown({ mobileSubscription: tempCoMobileSubscriptions, setDropdownContent });
      } else if (coMobileEligible.length > 0 && !csMobileEligible) {
        isChangeOfferEligible = {
          value: true,
          CoEligiblenumber: coMobileEligible.length,
          coEligiblityDetails: coMobileEligible,
        };
        const tempCoMobileSubscriptions = coMobileEligible || [];
        setCoMobileSubscriptions(tempCoMobileSubscriptions);
        if (tempCoMobileSubscriptions)
          setCookie('ION', 'selected_subscription', JSON.stringify(tempCoMobileSubscriptions));
        fillDropdown({ mobileSubscription: tempCoMobileSubscriptions, setDropdownContent });
      } else if (csMobileEligible && coMobileEligible.length === 0) {
        isCrossSellEligible = true;
      }
      setCustomerEligibility(EligibilityData);
    }
    // This else if will be called OnLoad if we have eligibility prop value, no need of client side call.
    else if (Object.keys(Eligibility).length !== 0 && token) {
      const filteredMobileSubs = Eligibility?.subscriptions?.filter(
        sg => sg?.serviceGroup === 'MOBILE'
      );
      const coMobileEligible = filteredMobileSubs?.filter(
        ele =>
          ele?.coEligiblity?.contractRenewal === true &&
          ele?.coEligiblity?.chargeCode !== 'UPFRONT_ECC'
      );
      const csMobileEligible = Eligibility?.crossSellEligibility?.serviceGroups?.filter(
        servicegrp => servicegrp.serviceGroup === 'MOBILE'
      )[0]?.eligible;
      if (
        coMobileEligible.length > 0 &&
        csMobileEligible &&
        !hasLocalStorageValue('ION_UPGRADE_NUMBER')
      ) {
        if (getCookie('cart_Type') === 'CHANGE_OFFER' && getCookie('channel') === 'MYEIR') {
          isChangeOfferEligible = {
            value: true,
            CoEligiblenumber: coMobileEligible.length,
            coEligiblityDetails: coMobileEligible,
          };
          const tempCoMobileSubscriptions = coMobileEligible || [];
          setCoMobileSubscriptions(tempCoMobileSubscriptions);
          if (tempCoMobileSubscriptions)
            setCookie('ION', 'selected_subscription', JSON.stringify(tempCoMobileSubscriptions));
          fillDropdown({ mobileSubscription: tempCoMobileSubscriptions, setDropdownContent });
        } else {
          loadJourneyPickerModal =
            getCookie('cart_Type') !== 'CHANGE_OFFER' && getCookie('cart_Type') !== 'CROSS_SELL';
          const tempCoMobileSubscriptions = coMobileEligible || [];
          setCoMobileSubscriptions(tempCoMobileSubscriptions);
          if (tempCoMobileSubscriptions)
            setCookie('ION', 'selected_subscription', JSON.stringify(tempCoMobileSubscriptions));
          fillDropdown({ mobileSubscription: tempCoMobileSubscriptions, setDropdownContent });
        }
      } else if (hasLocalStorageValue('ION_UPGRADE_NUMBER')) {
        isChangeOfferEligible = {
          value: true,
          CoEligiblenumber: coMobileEligible.length,
          coEligiblityDetails: coMobileEligible,
        };
        const tempCoMobileSubscriptions = coMobileEligible || [];
        setCoMobileSubscriptions(tempCoMobileSubscriptions);
        if (tempCoMobileSubscriptions)
          setCookie('ION', 'selected_subscription', JSON.stringify(tempCoMobileSubscriptions));
        fillDropdown({ mobileSubscription: tempCoMobileSubscriptions, setDropdownContent });
      } else if (coMobileEligible.length > 0 && !csMobileEligible) {
        isChangeOfferEligible = {
          value: !getLocalStorage('PROSPECTUUID'),
          CoEligiblenumber: coMobileEligible.length,
          coEligiblityDetails: coMobileEligible,
        };
        const tempCoMobileSubscriptions = coMobileEligible || [];
        setCoMobileSubscriptions(tempCoMobileSubscriptions);
        if (tempCoMobileSubscriptions)
          setCookie('ION', 'selected_subscription', JSON.stringify(tempCoMobileSubscriptions));
        fillDropdown({ mobileSubscription: tempCoMobileSubscriptions, setDropdownContent });
      } else if (csMobileEligible && coMobileEligible.length === 0) {
        isCrossSellEligible = !getLocalStorage('PROSPECTUUID');
      }
      setCustomerEligibility(Eligibility);
    }
    return { loadJourneyPickerModal, isCrossSellEligible, isChangeOfferEligible };
  } catch (error) {
    console.error(error);
  }
};
/**
 * @name onLoadValuesInitializer - This function will be called on load of the handsets page and used
 * for performing all static work which we wanted to perform. The main aim is to clean the index.js page to have clear visibility.
 * If we need to perform any thing on load this can be used.
 */
export const onLoadValuesInitializer = ({
  journeyData,
  setCode,
  getTokenFromCookies,
  dispatch,
  localStore,
  hasLocalStorageValue,
  getCookie,
  setJourneyType,
  setState,
}) => {
  let openAbondonCheckModal = false;
  if (journeyData?.cartType === 'CROSS_SELL') {
    setCode('CS');
    if (getTokenFromCookies()?.length > 0) {
      dispatch({
        type: 'LOGIN',
        payload: { email: getCookie('email_Address') },
      });
    }
  }

  if (journeyData.cartType === 'CHANGE_OFFER') {
    setCode('CO');
    if (getCookie('selected_subscription')) {
      const cartType = getCookie('cart_Type');
      setJourneyType(cartType);
      const subs = JSON.parse(getCookie('selected_subscription'));
      if (subs?.serviceGroup === 'DUALPLAY') {
        openAbondonCheckModal = true;
      }
    }
  }

  if (localStore.hasValue('PREQUAL_RESULT')) {
    setState();
  }

  if (localStore.hasValue('STANDALONE_PORTIN')) {
    localStore.removeLocalStorage('STANDALONE_PORTIN');
  }

  const openAccountCheckModal =
    !localStore.hasValue('PREQUAL_RESULT') &&
    !hasLocalStorageValue('ION_EXISTING_CUSTOMER') &&
    !journeyData.token;

  return {
    openAccountCheckModal,
    openAbondonCheckModal,
  };
};
